module.exports = __webpack_public_path__ + "img/btn-talk.3a2d366e.png";